/**
 * Matches nothing: a board whose projects have all been archived (they drop out
 * of the schema snapshot) must show an empty board, not every issue in the
 * instance. `#Resolved #Unresolved` is a contradiction the resolver accepts.
 */
const MATCHES_NOTHING = "#Resolved #Unresolved";
/**
 * The query whose result is the board's cards: the board's projects as a
 * `project:` clause, narrowed by the board's own filter. Since v0.13.19 the
 * projects live in `projectIds`, not in the query text, so everything that
 * loads cards (the board page, the auto-add-to-sprint check, the REST shape)
 * has to compose them the same way — hence this one helper.
 */
export function boardQuery(board, schema) {
    const filter = board.query.trim();
    if (board.projectIds.length === 0)
        return filter;
    const keys = board.projectIds.map((id) => schema.projectsById.get(id)?.key).filter((k) => k !== undefined);
    if (keys.length === 0)
        return MATCHES_NOTHING;
    const scope = `project: ${keys.join(", ")}`;
    return filter ? `${scope} ${filter}` : scope;
}
//# sourceMappingURL=board-query.js.map